import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export const clientIdentificationInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.serviceBase)) {
    return next(req);
  }

  return next(req.clone({
    setHeaders: {
      'X-Hivelog-Client': 'hivelog2',
      'X-Hivelog-Api-Version': environment.apiVersion,
      'X-Hivelog-Client-Version': environment.version
    }
  }));
};
